// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"FullScreen_fullscreen__bRJqz","fullscreen--search":"FullScreen_fullscreen--search__b_wmx"};